// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFunctions } from "firebase/functions";
// import { getFunctions, connectFunctionsEmulator } from "firebase/functions";

import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyA4a79-HTr-eQc6k67S_mKbWry1cSJTMtE",
  authDomain: "vallhund-dev-webpage.firebaseapp.com",
  projectId: "vallhund-dev-webpage",
  storageBucket: "vallhund-dev-webpage.appspot.com",
  messagingSenderId: "640005234991",
  appId: "1:640005234991:web:06894d08e3ebc9061cc1da",
  measurementId: "G-VZC5QHNY8Z",
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const functions = getFunctions(app);
// connectFunctionsEmulator(functions, "localhost", 5001);
